import type { Album } from '@/types'

export const albums: Album[] = [
  {
    id: '2026-Competition',
    heading: '2026',
    subheading: 'Competition',
    image: require('@/assets/gallery/2026-Competition/cover.jpg'), // TODO: Add cover.jpg
    title: '2026 Competition Season',
    intro: 'March 2026' // TODO: Update with actual dates
  },
  {
    id: '2026-Kickoff',
    heading: '2026',
    subheading: 'Kickoff',
    image: require('@/assets/gallery/2026-Kickoff/cover.jpg'),
    title: '2026 Kickoff',
    intro: 'January 2026 - CONVERGE Center'
  },
  {
    id: '2025-Magic-of-Science',
    heading: '2025',
    subheading: 'Magic of Science',
    image: require('@/assets/gallery/2025-Magic-of-Science/cover.jpg'),
    title: '2025 Magic of Science',
    intro: 'Summer 2025 Outreach'
  },
  {
    id: '2025-Pasadena',
    heading: '2025',
    subheading: '2025 Pasadena',
    image: require('@/assets/gallery/2025-Pasadena/cover.jpg'),
    title: '2025 Pasadena',
    intro: 'March 2025'
  },
  {
    id: '2024-Competition',
    heading: '2024',
    subheading: '2024 Competition Season',
    image: require('@/assets/gallery/2024-Competition/cover.jpg'),
    title: '2024 Competition Season',
    intro: 'March 2024'
  },
  {
    id: '2024-Build',
    heading: '2024',
    subheading: '2024 Build Season',
    image: require('@/assets/gallery/2024-Build/cover.jpg'),
    title: '2024 Build Season',
    intro: 'Began January 6, 2024'
  },
  {
    id: '2023-Alexandria',
    heading: '2023',
    subheading: 'Alexandria - Week 3',
    image: require('@/assets/gallery/2023-Alexandria/cover.jpg'),
    title: 'CHS District Alexandria VA Event',
    intro: 'March 17 to March 19, 2023 - Hayfield Secondary School'
  },
  {
    id: '2023-Offseason',
    heading: '2023',
    subheading: 'Offseason',
    image: require('@/assets/gallery/2023-Offseason/cover.jpg'),
    title: '2023 Offseason',
    intro: 'Summer 2023'
  },
  {
    id: '2022-BoB',
    heading: '2022',
    subheading: 'Battle of Baltimore',
    image: require('@/assets/gallery/2022-BoB/cover.jpg'),
    title: '2022 Battle of Baltimore',
    intro: 'October 22, 2022 - Dulaney High School'
  },
  {
    id: '2022-Offseason',
    heading: '2022',
    subheading: 'Offseason',
    image: require('@/assets/gallery/2022-Offseason/cover.jpg'),
    title: '2022 Offseason',
    intro: 'Science Fair, Fund Raising, Techbrick'
  },
  {
    id: '2022-District',
    heading: '2022',
    subheading: 'Districts',
    image: require('@/assets/gallery/2022-District/cover.jpg'),
    title: '2022 FIRST Chesapeake District Championship',
    intro: 'April 7-9, 2022 at the Hampton Coliseum, Hampton, Virginia'
  },
  {
    id: '2022-Qualifiers',
    heading: '2022',
    subheading: 'Qualifiers',
    image: require('@/assets/gallery/2022-Qualifiers/cover.jpg'),
    title: '2022 FIRST Chesapeake District Qualifiers',
    intro: 'March 12, 2022 and March 20, 2022'
  },
  {
    id: '2022-Build',
    heading: '2022',
    subheading: 'Build Season',
    image: require('@/assets/gallery/2022-Build/cover.jpg'),
    title: '2022 Build',
    intro: 'Began January 8, 2022'
  },
  {
    id: '2019',
    heading: '2019',
    subheading: 'Deep Space',
    image: require('@/assets/gallery/2019/cover.jpg'),
    title: '2019 Season',
    intro: ''
  }
]
